import React from 'react'
import { RouteComponentProps } from 'react-router'
import { Card, Button, Modal } from 'antd'

import { isEmpty, map } from 'lodash'
import { ComponentExt } from 'util/reactExt'

import styles from './index.scss'

import LicenseSwiper from './components/LicenseSwiper'
import Menus from '../components/Menus'
import TimeTree from './components/TimeTree'

interface IProps extends RouteComponentProps<any> {}
interface IState {}

class License extends ComponentExt<IProps, IState> {
  state = {
    license: [],
    banner: [],
    bannerIdx: 1,
    imgUrl: '',
    modalVisible: false,
  }

  async componentDidMount() {
    this.handleFetchLicenseList()
  }

  async handleFetchLicenseList() {
    try {
      const { data } = await this.api.family.getFamilyLicenceList({
        page: 1,
        limit: 999,
      })
      const banner = [
        ...map(data, (itm, idx) => {
          return itm.img
        }),
      ]
      this.setState(
        {
          license: data,
          banner,
        },
        () => {},
      )
    } catch (err) {
      console.error(err.message)
    }
  }

  handleSwiperChange = e => {
    // console.log('e', e)
    this.setState({ bannerIdx: Number(e) })
  }

  renderLicense = (data, type) => {
    return (
      <>
        {type && (
          <div
            className={styles.newImg}
            onClick={() => this.handleShowModal(data.img)}
          >
            <img src={data.img} alt="" />
          </div>
        )}
        <div className={styles.newInfo}>
          <h3>{data.title}</h3>
          <Button type="primary" shape="round" size="small">
            {data.date}
          </Button>
          <p>颁发单位：{data.issue_institution}</p>
          <p>{data.content}</p>
        </div>
      </>
    )
  }

  handleShowModal = imgurl => {
    this.setState({
      modalVisible: true,
      imgUrl: imgurl,
    })
  }

  handleModalCancel = () => {
    this.setState({ modalVisible: false, imgUrl: '' })
  }

  render() {
    const {
      state: { license, banner, bannerIdx, modalVisible, imgUrl },
      handleModalCancel,
      handleShowModal,
      renderLicense,
    } = this

    return (
      <div className={styles.license}>
        <div className={styles.menu}>
          <Menus defaultKey="license" />
        </div>
        <Card title="最新实力" bordered={false} style={{ width: 1200 }}>
          {!isEmpty(license) && renderLicense(license[0], true)}
        </Card>
        <Card
          className={styles.horList}
          title="荣誉长廊"
          bordered={false}
          style={{ width: 1200 }}
        >
          <TimeTree data={license} />
        </Card>
        <Card title="荣誉展示" bordered={false} style={{ width: 1200 }}>
          {!isEmpty(banner) && (
            <LicenseSwiper
              handleSwiperChange={this.handleSwiperChange}
              handleClickBanner={handleShowModal}
              data={banner}
            />
          )}
          {!isEmpty(license) && renderLicense(license[bannerIdx], false)}
        </Card>
        <Modal
          centered
          width={1000}
          footer={null}
          visible={modalVisible}
          onCancel={handleModalCancel}
          destroyOnClose
        >
          <img style={{ width: '100%', height: '100%' }} src={imgUrl} alt="" />
        </Modal>
      </div>
    )
  }
}

export default License
